import styled from "styled-components";

export const FloatingSubMenu = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 155px;
  background: black;
  z-index: 15;
  height: 300px;

  max-width: 1550px;
  margin: 0 auto;

  &.scroll-down {
    position: fixed;
    top: 60px;
    max-width: 100%;
  }

  ul {
    display: flex;
    justify-content: space-around;
    color: white;
    max-width: 950px;
    margin: 0 auto;

    li {
      text-align: center;
      position: relative;
      z-index: 9;
      flex-grow: 1;

      @media (max-width: 767.98px) {
        flex: 1 0 100% !important;
      }
      &.long {
        img.icon-offer {
          /* margin-bottom: 10px !important; */
          height: 140px !important;
          /* margin-top: 5px !important; */
        }
      }
      &.sell {
        img.icon-offer {
          height: 140px !important;
          /* margin-top: 50px !important; */
        }
      }
      a {
        display: block;
        position: relative;
        text-decoration: none;
        transition: all 0.3s ease;
        margin: 60px 0;
        border-right: 1px solid #2d2e30;

        img {
          width: auto;
          margin: 0 auto;
          cursor: pointer;
          transition: all 0.3s ease;
          &.icon-offer {
            padding-bottom: 0px;
          }
          &.arrow-icon {
            bottom: 0;
            height: 14px;
            margin-top: 35px;
            opacity: 0;
            position: absolute;
            transition: all 0.3s ease;
            left: 0;
            margin-left: auto;
            margin-right: auto;
            right: 0;
          }
          &:hover {
            cursor: pointer;
          }
        }
        h5 {
          color: white;
          transition: all 0.3s ease;
          margin-top: 23px;
          font-size: 15px;
          font-weight: 600;
        }
        &:hover {
          h5 {
            text-decoration: underline;
            color: #ff5000;
          }
        }
      }
    }
    li:last-child {
      a {
        border-right: 1px solid transparent;
      }
    }
  }
`;
